import axiosInstance from "../../utils/AxiosInstance";
import axiosInstanceForm from "../../utils/AxiosInstance";
export const CreateRoleAPi = async (data) => {
  let snackBarData = {};
  try {
    let response = await axiosInstanceForm.post("/Role/Create", data);

    snackBarData = {
      type: response?.data?.success ? "success" : "error",
      message: response?.data?.message,
      openToast: true,
    };

    return { ...response?.data, snackBarData };
  } catch (error) {
    snackBarData = {
      type: "error",
      message: error?.response?.data?.message,
      openToast: true,
    };
    return { ...error?.response, snackBarData };
  }
};

export const UpdateRoleAPi = async (roleId, data) => {
  let snackBarData = {};
  try {
    let response = await axiosInstanceForm.put(`/Role/Update/${roleId}`, data);

    snackBarData = {
      type: response?.data?.success ? "success" : "error",
      message: response?.data?.message,
      openToast: true,
    };

    return { ...response?.data, snackBarData };
  } catch (error) {
    snackBarData = {
      type: "error",
      message: error?.response?.data?.message,
      openToast: true,
    };
    return { ...error?.response, snackBarData };
  }
};

export const DeleteRoleAPi = async (roleId) => {
  let snackBarData = {};
  try {
    let response = await axiosInstance.delete(`/Role/Delete/${roleId}`);

    snackBarData = {
      type: response?.data?.success ? "success" : "error",
      message: response?.data?.message,
      openToast: true,
    };

    return { ...response?.data, snackBarData };
  } catch (error) {
    snackBarData = {
      type: "error",
      message: error?.response?.data?.message,
      openToast: true,
    };
    return { ...error?.response, snackBarData };
  }
};
